import { Role } from "@/router/_helper";

  const medicalAlert = {
    path: "/medicalAlert",
    name: "medicalAlert",
    component: () => import(/* webpackChunkName: "medical_alert" */ "@/components/medicalAlert/MedicalAlertIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "medical_alert" */ "@/components/medicalAlert/MedicalAlertView.vue"), name: "medicalAlertView", meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true } },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "medical_alert" */ "@/components/medicalAlert/MedicalAlertEdit.vue"), name: "medicalAlertEdit", meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true } },
      { path: "create", component: () => import(/* webpackChunkName: "medical_alert" */ "@/components/medicalAlert/MedicalAlertCreate.vue"), name: "medicalAlertCreate", meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true }}
    ],
    meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true }
  };

export default medicalAlert;
    